import * as React from 'react';
import moment from 'moment';
import { Moment } from "moment";
import { connect, ConnectedProps } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { RouteComponentProps } from 'react-router';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { ApplicationState } from '../store';
import * as AuthenticateStore from '../store/AuthenticateStore';
import * as LeaveRequestStore from '../store/LeaveRequestStore';
import * as UserStore from '../store/UserStore';
import * as LeaveTypeStore from '../store/LeaveTypeStore';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';

import { tableIcons } from '../bug-fix/mui-table-tableicons';
import MaterialTable, { Column } from 'material-table';
import MuiTable from '../i18n/MuiTable';
import { LeaveRequest as LeaveRequestModel, LeaveRequestStatus } from '../model';
import {
    Card,
    CardHeader,
    CardContent,
    Divider,
    Button,
    ButtonGroup,
    IconButton,
    LinearProgress,
    Paper,
    Tab,
    Tabs,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    Typography,
} from '@material-ui/core';
import {
    Edit as EditIcon,
} from '@material-ui/icons';

import LeaveTypeFilter from '../component/LeaveType/LeaveTypeFilter';
import UserFilter from '../component/User/UserFilter';
import SelectFilter from '../component/MuiTable/SelectFilter';
import UserName from '../component/UserName'
import LeaveTypeName from '../component/LeaveTypeName'
import dateSearch from '../helper/dateSearch';
import userSorting from '../helper/userSorting';
import leaveTypeSorting from '../helper/leaveTypeSorting';
import { number } from 'yup';
import { isNullOrUndefined } from 'util';

const mapStateToProps = (state: ApplicationState) => {
    return {
        auth: state.authenticate,
        user: state.user,
        leavedRequest: state.leavedRequest,
        leaveType: state.leaveType,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators({
        ...UserStore.actionCreators,
        ...LeaveRequestStore.actionCreators,
        ...LeaveTypeStore.actionCreators,
    }, dispatch)
}

const connector = connect(
    mapStateToProps,
    mapDispatchToProps,
)

type PropsFromRedux = ConnectedProps<typeof connector>

// At runtime, Redux will merge together...
type LeaveRequestProps =
    {
    }
    & RouteComponentProps<{}> // ... plus incoming routing parameters
    & WithTranslation
    & PropsFromRedux

const useStyles = {
    root: {
        width: '100%',
    },
    container: {
        maxHeight: '100%',
    },
};

type LeaveRequestState = {
    columns: Array<Column<LeaveRequestModel>>,
    filter?: number | undefined,
}

const leaveTypes = [
    { id: '1', title: 'Annual Leave' },
    { id: '2', title: 'Sick Leave' },
    { id: '3', title: 'Compassionate Leave' }
];

const defaultSort = (x: LeaveRequestModel, y: LeaveRequestModel): number => {
    if (// if both is pending approve or both not, order by submition date
        (
            (x.status == LeaveRequestStatus.PendingApprove)
            &&
            (y.status == LeaveRequestStatus.PendingApprove)
        )
        ||
        (
            (x.status != LeaveRequestStatus.PendingApprove)
            &&
            (y.status != LeaveRequestStatus.PendingApprove)
        )
    ) {
        if (isNullOrUndefined(x.createdDate) || isNullOrUndefined(y.createdDate))
            return 0;
        return 1 - x.createdDate.diff(y.createdDate);
    }

    if (x.status == LeaveRequestStatus.PendingApprove) {
        return -1;
    }

    if (y.status == LeaveRequestStatus.PendingApprove) {
        return 1;
    }
    return 0;
}

class LeaveRequest extends React.PureComponent<LeaveRequestProps, LeaveRequestState> {


    constructor(prop: LeaveRequestProps) {
        super(prop)

        this.state = {
            columns: [
                {
                    title: '',
                    sorting: false,
                    // cellStyle: {
                    //     width: "3rem",
                    //     maxWidth: "10%"
                    // },
                    width: 70,
                    render: rowData => <React.Fragment>
                        <IconButton
                            component={Link}
                            to={"/leave_request/" + rowData.id}
                            size="small"
                        >
                            <EditIcon />
                        </IconButton>
                        {rowData.nextApprover == 1 &&
                            <IconButton
                                component={Link}
                                to={"/leave_request/" + rowData.id}
                                size="small"
                            >
                                <EditIcon />
                            </IconButton>
                        }
                    </React.Fragment>
                },
                {
                    title: this.props.i18n.t('leave_request.request_id'),
                    field: 'requestId',
                },
                {
                    title: this.props.i18n.t('leave_request.applicant'),
                    field: 'applicant',
                    width: '20%',
                    render: rowData => <UserName userid={rowData.applicant ? rowData.applicant : 0} />,
                    customSort: userSorting({ field: 'applicant', userState: this.props.user }),
                    filterComponent: UserFilter,
                    lookup: {}, // empty is must, to let stupid MuiTable know is array of key
                },
                {
                    title: this.props.i18n.t('leave_request.leave_type'),
                    field: 'leaveTypeId',
                    width: '20%',
                    render: rowData => <LeaveTypeName leaveTypeId={rowData.leaveTypeId ? rowData.leaveTypeId : 0} />,
                    customSort: leaveTypeSorting({ field: 'leaveTypeId', leaveTypeState: this.props.leaveType }),
                    filterComponent: LeaveTypeFilter,
                    lookup: {}, // empty is must, to let stupid MuiTable know is array of key
                },
                {
                    title: this.props.i18n.t('status'),
                    field: 'status',
                    filterComponent: SelectFilter,
                    render: rowData => rowData.status == null ? '' : this.props.i18n.t('common_status.' + rowData.status.toLowerCase()),
                    lookup: {
                        "pending_approval": this.props.i18n.t('common_status.pending_approval'),
                        "approved": this.props.i18n.t('common_status.approved'),
                        "rejected": this.props.i18n.t('common_status.rejected'),
                        "withdraw": this.props.i18n.t('common_status.withdraw'),
                    },
                },
                {
                    title: this.props.i18n.t('create_at'),
                    field: 'createdDate',
                    customFilterAndSearch: dateSearch('createdDate'),
                    render: rowData => {
                        if (rowData.createdDate)
                            return (
                                <span>{rowData.createdDate.format('YYYY-MM-DD')}</span>
                            )
                        else
                            return (
                                <span>??????</span>
                            )
                    },
                },
            ],
            filter: 0,
        }
    }

    // This method is called when the component is first added to the document
    public componentDidMount() {
        this.ensureDataFetched();
    }

    // This method is called when the route parameters change
    public componentDidUpdate() {
        //this.ensureDataFetched();
    }

    public filteredData(): LeaveRequestModel[] {
        let currentUserID = 0;
        if (this.props.auth !== undefined && this.props.auth.user) {
            currentUserID = this.props.auth.user.id;
        }
        if (this.props.leavedRequest === undefined) {
            return [];
        }

        if (!isNullOrUndefined(this.state.filter) && this.state.filter > 0) {
            switch (this.state.filter) {
                case 1:
                    return this.props.leavedRequest.leaveRequestList.filter(x => x.applicant == currentUserID);
                case 2:
                    return this.props.leavedRequest.leaveRequestList.filter(x => x.nextApprover == currentUserID);
                default:
                    return this.props.leavedRequest.leaveRequestList;
            }
        }
        return this.props.leavedRequest.leaveRequestList;
    }

    public render() {
        return (
            <React.Fragment>
                <Card>
                    <CardHeader
                        // subheader={this.props.i18n.t('leave_request.sub_title')}
                        title={this.props.i18n.t('leave_request.title')}
                    />
                    <Divider />
                    <CardContent>
                        <div style={{ display: 'flex', marginBottom: 16 }}>
                            <div style={{ flexGrow: 1 }}>
                            </div>
                            <Button
                                component={Link}
                                to={"/leave_request/add"}
                                color="primary"
                                variant="contained">{this.props.i18n.t('leave_request.new')}</Button>
                        </div>
                        {this.renderFsorecastsTable()}
                    </CardContent>
                </Card>
            </React.Fragment>
        );
    }

    private ensureDataFetched() {
        this.props.requestLeaveRecord(undefined);
    }

    private renderFsorecastsTable() {
        return (
            <Paper>
                <Tabs
                    value={this.state.filter}
                    onChange={(e, v) => { this.setState({ filter: v }); }}
                    //onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                >
                    <Tab label={this.props.i18n.t('all')} />
                    <Tab label={this.props.i18n.t('my_application')} />
                    <Tab label={this.props.i18n.t('waiting_my_approval')} />
                </Tabs>
                {this.props.leavedRequest !== undefined && this.props.leavedRequest.isLoading && <LinearProgress />}

                <MaterialTable
                    icons={tableIcons}
                    columns={this.state.columns}
                    data={this.filteredData().sort(defaultSort)}
                    isLoading={this.props.leavedRequest === undefined || this.props.leavedRequest.isLoading}
                    localization={MuiTable(this.props.i18n)}
                    options={{
                        filtering: true,
                        search: false,
                        showTitle: false,
                        pageSize: 10,
                        toolbar: false,
                        headerStyle: { backgroundColor: '#9e9e9e', color: 'white', whiteSpace: 'nowrap' },
                    }}
                />
            </Paper>
        );
    }

}

export default compose(
    withTranslation(),
    withStyles(useStyles),
    connector,
)(LeaveRequest as any);
